class NwBlogWithFilters extends HTMLElement {
  constructor() {
    super();

    // The page size is hardcoded as it is hardcoded in blog.wellness-list-ajax.liquid. Set to match here. Dunno if it needs to. -PS
    this.pageSize = 12;
    this.totalPages = 1;
    this.currentPage = 1;

    this.selectedTag = null;

    this.loading = true;
    this.firstLoad = true;
    this.scrollToArticle = null;

    this.ajaxTemplate = this.dataset.templateName;
    this.blogHandle = this.dataset.blogHandle;

    this.articlesHolder = this.querySelector('.articles-list');
    this.postCategoriesCheckboxes = this.querySelectorAll(
      '.posts-categories input[type="checkbox"]'
    );
    this.filterToggle = this.querySelector('.filter-link a');
    this.filterList = this.querySelector('.posts-categories');
    this.filterListInputs = this.querySelectorAll(
      '.posts-categories input'
    );
    this.paginationNavContainer = this.querySelector(
      '.pagination-container'
    );
    this.loadingIcon = this.querySelector('.loading-container');
    this.filterStatus = this.querySelector('.filter-aria-status');

    this.bindListeners();
  }

  connectedCallback() {
    this.style.display = 'block';
  }

  initFilters() {
    if (!this.selectedTag) {
      const params = new Proxy(
        new URLSearchParams(window.location.search),
        {
          get: (searchParams, prop) => searchParams.get(prop),
        }
      );

      if (params.tag) {
        this.setSelectedTagIfExists(params.tag);
      }

      if (params.page) {
        const parsed = parseInt(params.page, 10);
        if (!Number.isNaN(parsed) && parsed > 0) {
          this.currentPage = parsed;
        }
      }

      if (params.aid) {
        // Prevent the browser restoring the position on history navigation
        window.history.scrollRestoration = 'manual';

        this.scrollToArticle = params.aid;
      }
    }
  }

  setSelectedTagIfExists(tagValue) {
    const currentTag = this.selectedTag;
    const tagCheckbox = this.querySelector(
      `.posts-categories input[value="${tagValue}"]`
    );

    if (tagCheckbox) {
      this.selectedTag = tagValue;

      this.querySelectorAll(
        `.posts-categories input:not([value="${tagValue}"])`
      ).forEach((checkbox) => {
        checkbox.checked = false;
      });
      tagCheckbox.checked = 'checked';
      this.updateAriaSelection(tagCheckbox);
    }

    return currentTag !== this.selectedTag;
  }

  setLoading(loading) {
    this.loading = loading;

    if (loading && this.firstLoad) {
      this.loadingIcon.classList.remove('d-none');
      this.loadingIcon.classList.add('d-block');
    } else {
      this.loadingIcon.classList.remove('d-none');
      this.loadingIcon.classList.remove('d-block');
      if (loading) {
        this.loadingIcon.classList.add('d-block');
      } else {
        this.loadingIcon.classList.add('d-none');
      }
    }
  }

  bindListeners() {
    window.addEventListener('load', () => {
      this.initFilters();

      this.fetchPage();
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        this.initFilters();

        this.fetchPage();
      }
    });

    window.addEventListener('popstate', (event) => {
      const eventState = event.state;

      if (eventState) {
        this.initFilters();

        const eventTag = event.state.selectedTag;
        const eventPage = event.state.currentPage;

        let shouldFetchPage = false;

        if (eventTag && this.setSelectedTagIfExists(eventTag)) {
          shouldFetchPage = true;
        }

        if (
          eventPage &&
          Number.isInteger(eventPage) &&
          eventPage > 0
        ) {
          this.currentPage = eventPage;
          shouldFetchPage = true;
        }

        if (shouldFetchPage) {
          this.fetchPage();
        }
      }
    });

    if (this.postCategoriesCheckboxes) {
      this.postCategoriesCheckboxes.forEach((checkboxTag) => {
        ['change'].forEach((evName) => {
          checkboxTag.addEventListener(evName, (ev) => {
            this.selectedTag = ev.target.checked
              ? ev.target.value
              : null;

            this.querySelectorAll(
              `.posts-categories input:not([value="${this.selectedTag}"])`
            ).forEach((checkbox) => {
              checkbox.checked = false;
            });
            this.updateAriaSelection(ev.target);

            this.currentPage = 1;
            this.fetchPage();

            this.pushCurrentState();
          });
        });

        checkboxTag.addEventListener('keydown', (ev) => {
          if (ev.key === 'Enter') {
            ev.preventDefault();
            ev.target.click();
          }
        });
      });
    }

    if (this.filterToggle && this.filterList) {
      // Disable Bootstrap's delegated collapse toggle so our custom handler is the only one running.
      this.filterToggle.removeAttribute('data-bs-toggle');
      this.filterToggle.removeAttribute('data-bs-target');

      // Start open by default (tabbable)
      this.filterList.classList.add('show');
      this.filterToggle.setAttribute('aria-expanded', 'true');
      this.setFiltersTabbable(true);

      ['click', 'touchend'].forEach((evName) => {
        this.filterToggle.addEventListener(evName, (ev) => {
          ev.preventDefault();
          ev.stopPropagation();

          const willShow =
            !this.filterList.classList.contains('show');
          this.filterList.classList.toggle('show', willShow);
          this.filterToggle.setAttribute(
            'aria-expanded',
            willShow ? 'true' : 'false'
          );
          this.setFiltersTabbable(willShow);
        });
      });
    }

    if (this.paginationNavContainer) {
      this.paginationNavContainer.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (this.loading) {
          return;
        }

        if (ev.target.closest('.pagination-container ul li a')) {
          const pageId = ev.target
            .closest('.pagination-container ul li a')
            .getAttribute('data-page');

          switch (pageId) {
            case 'next':
              this.currentPage = Math.min(
                this.totalPages,
                this.currentPage + 1
              );
              break;
            case 'prev':
              this.currentPage = Math.max(1, this.currentPage - 1);
              break;
            default:
              this.currentPage = Math.max(
                1,
                Math.min(this.totalPages, pageId)
              );
          }

          this.scrollToArticle = true;
          this.fetchPage();

          this.pushCurrentState();
        }
      });
    }

    if (this.articlesHolder) {
      this.articlesHolder.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (ev.target.closest('.article-item a')) {
          const articleItem = ev.target.closest('.article-item');
          const articleId = articleItem.getAttribute('data-id');

          if (articleId) {
            this.pushCurrentState(articleId);
          }

          const link = articleItem.querySelector('a.read-more-link');
          if (link) {
            window.location.href = link.href;
          }
        }
      });
    }

    this.updateAriaSelection();
  }

  pushCurrentState(articleId) {
    history.pushState(
      {
        selectedTag: this.selectedTag,
        currentPage: this.currentPage,
        articleId: articleId,
      },
      'Category: ' + this.selectedTag,
      `?page=${this.currentPage}&tag=` +
        (this.selectedTag
          ? encodeURIComponent(this.selectedTag)
          : '') +
        '&aid=' +
        (articleId || '')
    );
  }

  fetchPage() {
    const page = this.currentPage;
    const tag = this.selectedTag;

    let fetchUrl = `/blogs/${this.blogHandle}${
      tag ? '/tagged/' + this.getSlugForString(tag) : ''
    }?view=${this.ajaxTemplate}&page=${page}`;

    this.isFinalPageLoaded = false;
    this.setLoading(true);

    fetch(fetchUrl)
      .then((res) => {
        if (!res.ok) {
          console.error(
            'Got non-2xx response for articles listing request.'
          );

          return '';
        }

        return res.text();
      })
      .then((res) => {
        this.loading = false;

        if (this.articlesHolder) {
          const el = document.createElement('html');
          el.innerHTML = res;

          const articles = el.querySelectorAll(
            '#articles-container > div'
          );
          if (articles.length > 0) {
            this.articlesHolder.replaceChildren(
              ...el.querySelectorAll('#articles-container > div')
            );
            this.totalPages = parseInt(
              el.querySelector('#total-pages').innerText,
              10
            );
            this.currentPage = parseInt(
              el.querySelector('#current-page').innerText,
              10
            );
          } else if (this.currentPage !== 1) {
            // If the response is empty, fallback to the first page, only if this is not the first page already.
            this.currentPage = 1;
            this.totalPages = 1;

            this.fetchPage();
            this.pushCurrentState();

            return;
          }
        }

        this.renderPaginationNavigation();

        this.querySelector('#activeFilterSpan').innerHTML =
          tag || 'All';

        this.firstLoad = false;

        if (tag) {
          this.querySelectorAll('span.category-name').forEach(
            (elem) => {
              elem.innerHTML = tag;
            }
          );
        }

        this.querySelectorAll('.articles-list a').forEach((elem) => {
          const url = new URL(elem.href);
          if (tag) {
            url.searchParams.set('tag', tag);
          }
          if (this.currentPage > 1) {
            url.searchParams.set('blogPage', this.currentPage);
          }
          elem.href = url.href;
        });

        if (this.scrollToArticle) {
          const articleItem = this.querySelector(
            '#q-article-' + this.scrollToArticle
          );
          if (articleItem) {
            setTimeout(() => {
              window.scrollTo({ top: articleItem.offsetTop - 50 });
            }, 500);
          } else {
            this.scrollIntoView(true);
          }

          this.scrollToArticle = false;
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        this.setLoading(false);
      });
  }

  renderPaginationNavigation() {
    const ul = document.createElement(`ul`);
    ul.classList.add('pagination__list', 'list-unstyled');
    ul.role = 'list';

    if (this.totalPages > 1 && this.paginationNavContainer) {
      if (this.currentPage > 1) {
        ul.append(
          this.createPaginationItem('prev', '', true, [
            'chevron',
            'left',
          ])
        );
      }

      let li, firstDots, secondDots;
      for (let i = 1; i <= this.totalPages; i++) {
        if (i > 1 && this.currentPage - i > 2) {
          if (!firstDots) {
            li = this.createPaginationItem(i, '...', false);
            firstDots = true;
          }
        } else if (i < this.totalPages && i > this.currentPage + 2) {
          if (!secondDots) {
            li = this.createPaginationItem(i, '...', false);
            secondDots = true;
          }
        } else if (i === this.currentPage) {
          li = this.createPaginationItem(i, i, false, [
            'pagination__item--current',
          ]);
        } else {
          li = this.createPaginationItem(i, i, true);
        }

        ul.append(li);
      }

      if (this.currentPage < this.totalPages) {
        ul.append(
          this.createPaginationItem('next', '', true, [
            'chevron',
            'right',
          ])
        );
      }
    }

    this.paginationNavContainer.replaceChildren(ul);
  }

  createPaginationItem(pageId, label, withLink, linkExtraClasses) {
    const li = document.createElement('li');

    if (withLink) {
      const a = document.createElement('a');
      a.classList.add('pagination__item', 'link');
      if (linkExtraClasses) {
        a.classList.add(...linkExtraClasses);
      }
      a.innerText = label;
      a.href = '#';
      a.setAttribute('data-page', pageId);
      a.setAttribute('aria-label', `paginate to ${pageId} page`);
      li.appendChild(a);
    } else {
      const span = document.createElement('span');
      span.classList.add('pagination__item');
      span.innerText = label;
      if (linkExtraClasses) {
        span.classList.add(...linkExtraClasses);
      }
      li.appendChild(span);
    }

    return li;
  }

  getConvertedEventType(type) {
    if (isMobile()) {
      if (type === 'mousedown') {
        type = 'touchstart';
      } else if (type === 'click') {
        type = 'touchend';
      }
    }

    return type;
  }

  getSlugForString(string) {
    return string
      .toLowerCase()
      .replace(/[\'"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-$/, '')
      .replace(/^-/, '');
  }

  getYPositionOfList() {
    const rect = this.getBoundingClientRect();
    return rect.top;
  }

  setFiltersTabbable(isTabbable) {
    if (!this.filterListInputs || !this.filterListInputs.length) {
      return;
    }

    const tabIndexValue = isTabbable ? '0' : '-1';
    this.filterListInputs.forEach((node) => {
      node.setAttribute('tabindex', tabIndexValue);
      if (!isTabbable) {
        node.blur();
      }
    });
  }

  updateAriaSelection(selectedNode) {
    if (this.postCategoriesCheckboxes) {
      this.postCategoriesCheckboxes.forEach((checkbox) => {
        const isSelected =
          selectedNode === checkbox
            ? checkbox.checked
            : checkbox.checked && checkbox.value === this.selectedTag;

        checkbox.setAttribute('role', 'radio');
        checkbox.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      });
    }

    if (this.filterStatus) {
      const label = this.selectedTag || 'None';
      this.filterStatus.textContent = `Filter: ${label}`;
    }
  }
}

customElements.define('nw-blog-with-filters', NwBlogWithFilters);
